<template>
  <div class="body-wrapper">
    <QuestionImage
        :attaches="questionData?.content?.attach
    ?.filter(item => item.file?.attachUrl)
    ?.map(item => ({ attachUrl: item.file.attachUrl })) || []"
    />
    <h5 class="title">
      {{ questionData?.name }}
    </h5>

    <div class="options-wrapper" :class="{ 'image-grid': hasImageOptions }">
      <div
          class="option"
          :class="{
            'selected': selectedOptions?.includes(option?.id),
            'image-option': hasImageOptions
          }"
          v-for="option in questionData?.content?.options"
          @click="toggleOption(option?.id)"
          :key="option.id"
      >
        <ImageLoader
            v-if="option?.file?.attachUrl"
            :source="option.file?.attachUrl"
            :style="{
              width: '100%',
              aspectRatio: '1',
              borderRadius: '8px',
              marginBottom: '10px'
            }"
        />

        <div class="option-content">
          <img v-if="selectedOptions?.includes(option?.id)" src="@/assets/images/checkboxCheckedBlue.svg" width="18" height="18" />
          <img v-else src="@/assets/images/checkbox.svg" width="18" height="18" />

          <span>{{option.name}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionImage from "@/components/QuestionImage.vue";
import ImageLoader from "@/components/ImageLoader.vue";

export default{
  components: {QuestionImage, ImageLoader},
  props:{
    questionData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isGrading: false,
      isAnswerImage: false,
      maxGradingValue: 0,
      selectedOptions: [],
    };
  },
  computed: {
    hasImageOptions() {
      return this.questionData?.content?.options?.some(option => option?.file?.attachUrl) || false;
    }
  },
  watch: {
    questionData: {
      handler() {
        this.selectedOptions = [];
      },
      immediate: true,
      deep: true,
    }
  },
  methods: {
    toggleOption(optionId) {
      const index = this.selectedOptions.indexOf(optionId);

      if (index > -1) {
        this.selectedOptions.splice(index, 1);
      } else {
        this.selectedOptions.push(optionId);
      }
    },
  }
}
</script>

<style scoped>
.body-wrapper {
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 100%;
  padding: 10px;
}

.title {
  font-size: 18px;
  color: #040C2D;
  margin: 0;
  padding: 0;
  font-family: euclid_semi_bold, sans-serif;
}

.options-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin-top: 20px;
}

/* Grid layout for image options */
.options-wrapper.image-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.option {
  width: 100%;
  background-color: #F5F5F5;
  border-radius: 8px;
  padding: 15px 10px;
  flex-shrink: 1;
  border: 2px solid transparent;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  z-index: 1;
  cursor: pointer;
  transition: all 0.2s ease;
}

/* Image option styling */
.option.image-option {
  flex-direction: column;
  padding: 10px;
}

.option-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  width: 100%;
}

.option span {
  font-size: 14px;
  color: #040C2D;
  margin: 0;
  padding: 0;
  font-family: euclid_regular, sans-serif;
  flex: 1;
}

/* Smaller text for image options */
.option.image-option span {
  font-size: 12px;
}

.option.selected {
  border-color: #4A68F8;
  background-color: #d6ddff;
}


/* Prevent text overflow */
.option-content span {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>